import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const PrivateRouter = ({userValidacao: userValidacao, pathPageExpired: pathpageexpired, component: Component, ...rest}) => {
    const authlogin = userValidacao;    
    return (
        <Route
            {...rest}
            render={props => 
                authlogin && Object.keys(authlogin).length ? (
                <Component {...props}/>
            ) : (
                <Redirect to={{
                    pathname: pathpageexpired,
                    state: { from: props.location}
                }} />
            )}
        />
    )
};